import { Globe2, Users2 } from 'lucide-react';
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next";

const Reasons1 = () => {

  const { t } = useTranslation();

  const data = [
    { title: "reach_a_welth_of_travelers", image: "https://images.pexels.com/photos/34328172/pexels-photo-34328172.jpeg" },
    { title: "leverage_tech_built_for_your_business", image: "https://images.pexels.com/photos/3182829/pexels-photo-3182829.jpeg" },
    { title: "stand_out_with_powerful_advertising", image: "https://images.pexels.com/photos/244133/pexels-photo-244133.jpeg" }
  ]

  return (
 
     <div className='px-9'>
        <Row className='py-5 justify-content-between align-items-center row-gap-4'>
        <Col lg="5" xl="4">
          <h2 className='fs-1 text-blue'>{t('reasons_title')}</h2>
          <p className='mt-3' dangerouslySetInnerHTML={{ __html: t('reasons_caption') }}></p>
          <button className='py-3 px-5 rounded-3 mt-4' style={{ background: '#EBE2F7', fontSize: '90%' }}>{t('learn_more')}</button>
        </Col>
        <Col lg="7">
          <Row className='justify-content-end row-gap-3'>
            <Col sm="6" lg="8">
              <img className='rounded-5 border border-2 border-white' src='https://img.freepik.com/free-photo/young-female-traveler-enjoying-rural-surroundings_23-2149125532.jpg?t=st=1765980029~exp=1765983629~hmac=3c477c948cb5d3e13604b314ef4599384b5cfd5960289a3312607a853e942090&w=1480' alt='Jeune femme qui fait une randonnée dans une montagne' width="100%" height="100%" />
            </Col>
            <Col sm="6" lg="4" xl="3">
              <div className='d-flex flex-column justify-content-between h-100 gap-3'>
                <div className='rounded-4 border border-2 border-white shadow-sm p-3'>
                  <div className='text-blue'>
                    <Globe2 size={30} strokeWidth={1.5} />
                  </div>
                  <div className='fs-5 fw-medium text-blue mt-4'>{t('25_years')}</div>
                  <div>{t('experience')}</div>
                </div>
                <div className='border border-2 border-white  rounded-5 p-3 shadow ' style={{background: "#f5f5f5"}}>
                  <div className='text-blue'>
                    <Users2 size={30} strokeWidth={1.5} />
                  </div>
                  <div className='fs-5 fw-medium text-blue mt-4'>+100k</div>
                  <div>{t('active_users')}</div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

     </div>
  )
}

export default Reasons1



